import React from 'react';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';

const FAQsSection = ({ data, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const updateFAQ = (faqId, updates) => {
    const updatedFAQs = data.faqs.map(faq =>
      faq.id === faqId ? { ...faq, ...updates } : faq
    );
    handleChange('faqs', updatedFAQs);
  };

  const addFAQ = () => {
    const newFAQ = {
      id: `faq${Date.now()}`,
      question: '',
      answer: ''
    };
    handleChange('faqs', [...(data.faqs || []), newFAQ]);
  };

  const removeFAQ = (faqId) => {
    const updatedFAQs = data.faqs.filter(faq => faq.id !== faqId);
    handleChange('faqs', updatedFAQs);
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">FAQs Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row className="mb-4">
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Heading"
                  value={data.heading || ''}
                  onChange={(e) => handleChange('heading', e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Sub Heading</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Sub Heading"
                  value={data.subHeading || ''}
                  onChange={(e) => handleChange('subHeading', e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* FAQs */}
          <h6 className="fw-bold mb-3">FAQs</h6>
          {data.faqs?.map((faq, index) => (
            <div key={faq.id} className="border rounded p-3 mb-3 bg-light-subtle">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">FAQ {index + 1}</h6>
                {data.faqs.length > 1 && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => removeFAQ(faq.id)}
                  >
                    Remove
                  </Button>
                )}
              </div>
              <Form.Group className="mb-3">
                <Form.Label>Question</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Question"
                  value={faq.question}
                  onChange={(e) => updateFAQ(faq.id, { question: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-0">
                <Form.Label>Answer</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Answer"
                  value={faq.answer}
                  onChange={(e) => updateFAQ(faq.id, { answer: e.target.value })}
                />
              </Form.Group>
            </div>
          ))}
          <Button variant="outline-primary" onClick={addFAQ}>
            Add FAQ
          </Button>
        </Card.Body>
      )}
    </Card>
  );
};

export default FAQsSection;
